import { Modal } from "react-bootstrap";
import WithholdingList from "containers/property/WithholdingList";

function WithholdingModal({
    show,
    isAuthenticated,
    user,
    updateTableState,
    filter,
    saveForm,
    data,
    saveRecord,
    deleteRecord,
    onClose,
    validateRelatedRecord,
    userPermissions,
    withholdingReasons,
    bulkSaveRecords,
    refreshRecords,
}) {

    return (
        <Modal id="property-withholdings-modal" show={show} onHide={onClose} dialogClassName="property-table-modal-wide">
            <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body id="property-withholdings-modal-body" style={{ overflowX: "hidden" }}>
                <WithholdingList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    saveForm={saveForm}
                    user={user}
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    bulkSaveRecords={bulkSaveRecords}
                    refreshRecords={refreshRecords}
                    deleteRecord={deleteRecord}
                    validateRelatedRecord={validateRelatedRecord}
                    withholdingReasons={withholdingReasons}
                    userPermissions={userPermissions}
                />
            </Modal.Body>
        </Modal>
    );
}
export default WithholdingModal;